// The server's stamp on this phone's answer to the question on screen: how long after the start the server received
// it. Scores are worked out from that stamp, not from the tap, so a tap just before a clue falls due can still be
// scored with that clue. The answer view uses it to mark where the player really locked in. Read from the player's
// store (the accepted answer, else GET /me after a reload); undefined until the server has accepted the answer.
import { useGame } from '@/store/game';
import type { LiveQuestion } from './types';

export function useServerStamp(q: Pick<LiveQuestion, 'id' | 'startsAt'>, optionId?: string): number | undefined {
  return useGame((s) => {
    const snap = s.snapshot;
    if (!optionId || !snap?.question || snap.question.id !== q.id || snap.question.startsAt !== q.startsAt) return undefined;
    const mine = s.myAnswer;
    if (mine && mine.index === snap.index && mine.optionId === optionId && typeof mine.elapsedMs === 'number') return mine.elapsedMs;
    const saved = s.me?.answers?.[`q${snap.index}`];
    return saved && saved.optionId === optionId && typeof saved.elapsedMs === 'number' ? saved.elapsedMs : undefined;
  });
}
